import { clientAPI } from './client'

export async function getNonce(address: string): Promise<string> {
  const res = await clientAPI.post('/auth/nonce', { address })
  console.log(res);
  return res.data
}

export async function authLogin(address: string, signature: string): Promise<string> {
  const res = await clientAPI.post('/auth/login', { address, signature })
  return res.data
}
